import { g as r } from "./global.js";
import { f as e } from "./fails.js";
import { c as n } from "./check-correctness-of-iteration.js";
import { a as o } from "./array-buffer-view-core.js";
var t = o.NATIVE_ARRAY_BUFFER_VIEWS,
  a = r.ArrayBuffer,
  f = r.Int8Array,
  s = !t || !e(function () {
    f(1);
  }) || !e(function () {
    new f(-1);
  }) || !n(function (r) {
    new f(), new f(null), new f(1.5), new f(r);
  }, !0) || e(function () {
    return 1 !== new f(new a(2), 1, void 0).length;
  });
export { s as t };